import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { cardConfigs } from "@/puck/blocks/content/cardConfigs";
import { chartMockupConfigs } from "@/puck/blocks/content/chartMockupConfigs";
import { chatMockupConfigs } from "@/puck/blocks/content/chatMockupConfigs";
import { columnsConfigs } from "@/puck/blocks/content/columnsConfigs";
import { mediaConfigs } from "@/puck/blocks/content/mediaConfigs";
import { sectionConfigs } from "@/puck/blocks/content/sectionConfigs";
import { structureConfigs } from "@/puck/blocks/content/structureConfigs";
import { stepsConfigs } from "@/puck/blocks/content/stepsConfigs";
import { badgeConfigs } from "@/puck/blocks/content/badgeConfigs";
import { gptPageMockupContentConfigs } from "@/puck/blocks/content/gptPageMockupConfigs";
import { phoneVideoConfigs } from "@/puck/blocks/content/phoneVideoConfigs";
import { sectionHeadingConfigs } from "@/puck/blocks/content/sectionHeadingConfigs";

/** Component names that make up the generic "content" building blocks. */
export type ContentBlockName =
  | "Header"
  | "Hero"
  | "FeatureStrip"
  | "Logos"
  | "Workflows"
  | "Outcomes"
  | "BuyerQuote"
  | "FAQ"
  | "RichText"
  | "WistiaVideo"
  | "PartnerTicker"
  | "BookDemo"
  | "Snippet"
  | "Image"
  | "Columns"
  | "ChatMockup"
  | "ChartMockup"
  | "Card"
  | "SectionHeading"
  | "PhoneVideo"
  | "NumberedSteps"
  | "FloatingBadge"
  | "GptPageMockup"
  | "Footer";

export const contentBlocks: Pick<LandingComponents, ContentBlockName> = {
  ...structureConfigs,
  ...sectionConfigs,
  ...columnsConfigs,
  ...chatMockupConfigs,
  ...chartMockupConfigs,
  ...cardConfigs,
  ...sectionHeadingConfigs,
  ...phoneVideoConfigs,
  ...stepsConfigs,
  ...badgeConfigs,
  ...gptPageMockupContentConfigs,
  ...mediaConfigs,
};
